import omit from "lodash/omit";
import { Invoice } from "models";

export const sanitizeInvoicePayload = (formValues: Invoice) => {
  const invoicePayload = { ...omit(formValues, "noNumber") };

  if (formValues.invoice_type !== "IntermediaryReport") {
    delete invoicePayload.intermediary_report_number;
    delete invoicePayload.intermediary_report_date;
    delete invoicePayload.commission_amount;
    delete invoicePayload.commission_vat_rate;
    delete invoicePayload.commission_vat;
    delete invoicePayload.commission_amount_without_vat;
  }

  return invoicePayload;
};